import { Box, Container } from '@mui/material';
import { FeaturedArticles } from './FeaturedArticles';
import { DictionaryPreview } from './DictionaryPreview';
import { KC_COLORS } from '../theme';

export function FeaturedContentSplit() {
  return (
    <Box
      className="kc-featured w-full py-8 md:py-10"
      style={{ backgroundColor: KC_COLORS.lightGrey }}
    >
      <Container maxWidth="lg">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 lg:items-stretch">
          <div className="h-full min-h-0 flex flex-col">
            <FeaturedArticles />
          </div>
          <div className="h-full min-h-0 flex flex-col">
            <DictionaryPreview />
          </div>
        </div>
      </Container>
    </Box>
  );
}
